/**
 * Google Analytics + Google Ads
 **/

const GA_MEASUREMENT_ID = 'G-6L8XWX45R2';
// TODO: Replace with actual Google Ads Conversion ID when available
// const GOOGLE_ADS_ID = 'AW-XXXXXXXXX';

function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
        window.gtag = function gtag(){ window.dataLayer.push(arguments); };
    }
    return window.gtag;
}

export function initAnalyticsConsentDefaults() {
    const gtag = ensureGtag();

    // Default: deny all tracking until explicit consent
    gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    });
}

function loadGtagScript() {
    if (document.querySelector(`script[data-gtag="true"][data-id="${GA_MEASUREMENT_ID}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.dataset.gtag = 'true';
    script.dataset.id = GA_MEASUREMENT_ID;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
}

export function purgeAnalyticsScripts() {
    // In case a previous navigation injected gtag.js, remove it until consent is granted
    document.querySelectorAll(`script[src*="googletagmanager.com/gtag/js"][src*="${GA_MEASUREMENT_ID}"]`).forEach(s => s.remove());
    document.querySelectorAll(`script[data-gtag="true"][data-id="${GA_MEASUREMENT_ID}"]`).forEach(s => s.remove());
}

export function enableAnalytics() {
    const gtag = ensureGtag();
    gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
    });
    loadGtagScript();
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
        linker: {
            domains: ['maigret.es', 'entradas.bekamedia.es']
        }
    });
    // TODO: Uncomment when Google Ads Conversion ID is available
    // gtag('config', GOOGLE_ADS_ID);
}

export function disableAnalytics() {
    const gtag = ensureGtag();
    gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    });
}
